import { render, staticRenderFns } from "./CardTaskItemReadOnly.vue?vue&type=template&id=e254bd56&scoped=true"
import script from "./CardTaskItemReadOnly.vue?vue&type=script&lang=js"
export * from "./CardTaskItemReadOnly.vue?vue&type=script&lang=js"
import style0 from "./CardTaskItemReadOnly.vue?vue&type=style&index=0&id=e254bd56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e254bd56",
  null
  
)

export default component.exports